<template>
    <div class="TQ_padding_16px">

        <!-- hours -->
        <div class="TQ_inline TQ_border_2px TQ_verticalAlignMiddle TQ_width_52px TQ_box_shadow">

            <div class="TQ_text_20px TQ_textColor_white TQ_border_bottom">
               <div class="TQ_bg_purple TQ_padding_8px"> שעה </div>
            </div>

            <div v-for="(ignore,hour_n) in 24" class="TQ_border_bottom TQ_verticalAlignMiddle TQ_height_20px">
                {{m_dom_format_HHmm_fs( hour_n, 0)}}
            </div>
        </div>

        <!-- space -->
        <div class="TQ_padding_8px TQ_inline"></div>

        <!-- days -->
        <div class="TQ_inline TQ_border">
            <div v-for="(day_blc_s, dayIndex_n) in dayOfTheWeek_aBlcS"
                 class="TQ_inline TQ_border TQ_verticalAlignMiddle TQ_width_100px TQ_box_shadow">

                <div class="TQ_text_20px TQ_textColor_white TQ_border_bottom">
                    <div class="TQ_bg_purple TQ_padding_8px"> {{day_blc_s[ps_langCode_e]}} </div>
                </div>

                <div v-for="(ignore,hour_n) in 24"
                     @click="m_userEvent_clickCell_f(dayIndex_n, hour_n)"
                     class="lc_dayCell TQ_border_bottom TQ_verticalAlignMiddle TQ_height_20px TQ_clickable">
                    <div v-if="m_dom_getAvailableDateWithDayHour_fs(dayIndex_n, hour_n) != null" class="TQ_bg_green TQ_height_100p">
                        {{m_dom_getAvailableDateWithDayHour_fs(dayIndex_n, hour_n)}}
                    </div>
                </div>

            </div>
        </div>

        <!-- new availableDate popup-->
        <tq-popup :show="showPopup_vb"
                  width="100%"
                  maxWidth="200px"
                  :show-close-btn="true">

            <div class="TQ_padding_4px" v-if="newVal_availableEventDate_d">
                <div class="TQ_text_20px">
                    {{ass_strings.threeWords_newAvailableDate[ps_langCode_e]}}
                </div>
                <hr>

                <input type=time step=300 class="TQ_margin_bottom_16px TQ_input TQ_padding_4px"
                       @change="m_change_newVal_HHmm_f"
                       v-model="newVal_HHmm_s">

                <span >
                    {{ass_strings.oneWord_day[ps_langCode_e]}}
                    {{dayOfTheWeek_aBlcS[newVal_availableEventDate_d.getDay()][ps_langCode_e]}}
                </span>

                <div>
                    <div class="TQ_bg_purple TQ_btn" @click="m_userEvent_addAvailableDate_f"> {{ass_strings.oneWord_create[ps_langCode_e]}} </div>
                </div>
            </div>


        </tq-popup>

    </div>
</template>

<script>
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        validator_enum_fb,
    } from "../../../../../functions/src/shareCode/Share_S_Validator";
    import TqPopup from "../../../../components/basic/TqPopup";
    import {
        date_newDate_fd,
        date_newDate_withDayAndHour_ft,
        date_sameDayWeek_fb,
        date_sameHour_fb
    } from "../../../../scripts/S_Date";
    import {format_date_hh_mm_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import {validator_array_typeOf_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {enum_typeof} from "../../../../../functions/src/shareCode/Share_S_Enum";


    export default {

        name: "C_Creator_EditQuests_Item_Explore_AvailableDates",
        components: {TqPopup},
        props:{

            ps_langCode_e :{
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes,val)
                }
            },
            pb_qex_availableDates_at:{
                type: Array,
                require: true,
                validator(arr){
                    return validator_array_typeOf_fb(arr, enum_typeof.number)
                }
            }
        },
        data(){
            return{
                ass_strings : ass_strings,
                dayOfTheWeek_aBlcS : [ass_strings.oneWord_Sunday, ass_strings.oneWord_Monday, ass_strings.oneWord_Tuesday,ass_strings.oneWord_Wednesday,ass_strings.oneWord_Thursday,ass_strings.oneWord_Friday, ass_strings.oneWord_Saturday],
                showPopup_vb : {val : false},
                newVal_HHmm_s : null,
                newVal_availableEventDate_d : null,


            }
        },
        methods:{

            m_change_newVal_HHmm_f(){

                let hours_n = parseInt(this.newVal_HHmm_s.substring(0,2))
                let minutes_n = parseInt(this.newVal_HHmm_s.substring(3,5))

                this.newVal_availableEventDate_d.setHours(hours_n)
                this.newVal_availableEventDate_d.setMinutes(minutes_n)



            },

            // userEvent
            m_userEvent_clickCell_f(dayOfTheWeek_n, hour_n){

                let availableDateIndex_n = -1;
                let clickDate_t = date_newDate_withDayAndHour_ft(dayOfTheWeek_n, hour_n)

                for(let i=0; i < this.pb_qex_availableDates_at.length; i++){

                    // same dayOfTheWeek and hour
                    if( date_sameDayWeek_fb(this.pb_qex_availableDates_at[i], clickDate_t)
                        && date_sameHour_fb(this.pb_qex_availableDates_at[i], clickDate_t)){
                        availableDateIndex_n = i;
                        break;
                    }
                }

                if(availableDateIndex_n >= 0 ){
                    this.pb_qex_availableDates_at.splice(availableDateIndex_n,1)
                }else{
                    this.newVal_availableEventDate_d = date_newDate_fd(clickDate_t)

                    this.newVal_HHmm_s = format_date_hh_mm_fs(clickDate_t)
                    this.showPopup_vb.val   = true
                }
            },
            m_userEvent_addAvailableDate_f(){


                console.log(this.newVal_availableEventDate_d)
                this.pb_qex_availableDates_at.push(this.newVal_availableEventDate_d.getTime())
                this.newVal_availableEventDate_d  = null
                this.showPopup_vb.val = false

            },

            // dom
            m_dom_getAvailableDateWithDayHour_fs(dayOfTheWeek_n, hour_n){


                let cellDate_t = date_newDate_withDayAndHour_ft(dayOfTheWeek_n, hour_n)

                for(let i=0; i < this.pb_qex_availableDates_at.length; i++){

                    // same dayOfTheWeek and hour
                    if( date_sameDayWeek_fb(this.pb_qex_availableDates_at[i], cellDate_t)
                        && date_sameHour_fb(this.pb_qex_availableDates_at[i], cellDate_t)){

                        return format_date_hh_mm_fs(this.pb_qex_availableDates_at[i])
                    }
                }

                return null

            },
            m_dom_format_HHmm_fs(hour_n, minutes_n){

                if(hour_n < 10){hour_n = "0" + hour_n}
                if(minutes_n < 10){minutes_n = "0" + minutes_n}

                return `${hour_n}:${minutes_n}`
            },

        },



    }
</script>

<style scoped lang="scss">
    .lc_dayCell:hover{
        background: var(--color-green);
        div{
            background: var(--color-red);
        }
    }
</style>
